import { addToGlobalThisRet } from "@plugins";

function questionnaireCollapse() {
    const optionsBody = document.querySelectorAll(".js-questionnaire-collapse");

    if (optionsBody) {
        optionsBody.forEach((body) => {
            if (body.children.length > 3) {
                body.classList.add("collapsed");

                const showAllOptionsBtn = document.createElement("div");
                showAllOptionsBtn.classList.add("questionnaire__show-more");
                showAllOptionsBtn.textContent = "Ещё варианты ответа";
                showAllOptionsBtn.addEventListener("click", () => {
                    if (body.classList.contains("collapsed")) {
                        body.classList.remove("collapsed");
                        showAllOptionsBtn.textContent = "Скрыть варианты ответов";
                    } else {
                        body.classList.add("collapsed");
                        showAllOptionsBtn.textContent = "Ещё варианты ответа";
                    }
                });

                body.appendChild(showAllOptionsBtn);
            }
        });
    }
}

function resultsSetWidth() {
    const votesResultsWrap = document.querySelectorAll(".js-questionnaire-results");

    if (votesResultsWrap) {
        votesResultsWrap.forEach((wrap) => {
            const result = wrap.querySelector(".js-votes-results");
            const value = wrap.querySelector(".js-votes-value");

            if (result && value) {
                result.style.width = `${value.innerHTML}`;
            }
        });
    }
}

window.addEventListener("load", () => {
    questionnaireCollapse();
    resultsSetWidth();
});

addToGlobalThisRet(questionnaireCollapse, "questionnaireCollapse");
addToGlobalThisRet(resultsSetWidth, "resultsSetWidth");
